/* eslint-disable @typescript-eslint/naming-convention */

import { PresentationResponseType } from "../../../_types"
import { _mockSlidesResponse_0 } from "./SlidesResponses.mock"

export const _mockPresentation_0: PresentationResponseType = {
  PID: 135,

  title: "Bictegravir-Tenofovir alafenamide-Emtricitabine",
  subtitle: "MASTER Deck",
  summary: "",
  speaker: "",

  pdf_url: "bictegravirtenofovir_alafenamideemtricitabine.pdf",
  ppt_url: "",
  pptx_url: "bictegravirtenofovir_alafenamideemtricitabine.pptx",

  thumbnail: 1,
  filter_noise: 0,
  audio_combined: 0,
  time_skew: 0.000,
  audio_duraton: 0,

  ias_usa: 0,
  status: 20,
  podcast: 0,
  youtube_id: 0,
  youtube_published: 0,
  published: 1,
  number: 0,

  MID: 0,
  SMID: 0,
  created: "2022-11-23 17:06:52	5",
  updated: "2022-11-23 17:06:52	5",
  rev: 5,
  site_code: "nhivc",

  slides: _mockSlidesResponse_0
}
